import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/hazcheck-theme.css';
import './index.css';
import { applyTheme, loadTheme } from './theme';
import App from './App';

// Set the mode class before the first paint so a dark-mode user never sees a
// white flash while React mounts.
applyTheme(loadTheme());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
